import React from "react";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import SanctionDetailsOfBorrower from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionDetailsOfBorrower";
import Accordion from "../../common/components/accordion";
import SanctionCharges from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionCharges";
import SanctionForeclosureCharges from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionForeclosureCharges";
import SanctionPartPaymentCharges from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionPartPaymentCharges";
import SanctionLoanCancellation from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionLoanCancellation";
import SanctionLoanReschedulement from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionLoanReschedulement";
import SanctionInterStateNOC from "../../common/components/pageBlocks/sanctionLetterApproval/sanctionInterStateNOC";

export default function SanctionLetterApproval(props) {
    window.scrollTo(0, 0);
    return (
        <>
            <div className="wrapper">
                <HdfcHeader />
                <section className="sanction-letter-wrap mt-110">
                    <div className="container mx-auto px-5">
                        <div className="w-full">
                            <h1 className="openSans-Reg text-black my-5 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                Sanction Letter Approval
                            </h1>
                        </div>

                        <div className="w-full">
                            <ol>
                                <li className="list-decimal list-inside openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                    With reference to your request, we are
                                    pleased to sanction the Loan as under. The
                                    Loan shall be governed by the Terms and
                                    Conditions executed/to be executed by you
                                    ,as well as the terms and conditions of this
                                    Sanction Letter, without any further act,
                                    deed or writing.
                                </li>
                                <li className="list-decimal list-inside openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                    This sanction is subject to the acceptance
                                    of terms and conditions mentioned in this
                                    sanction letter and more particularly
                                    detailed in the Terms and Conditions, unless
                                    specifically waived by HDFC Bank Limited.
                                </li>
                                <li className="list-decimal list-inside openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                    The Loan is subject to the terms and
                                    conditions as set out in Annexure hereto
                                    (subject to change as per Reserve Bank of
                                    India (“RBI”) directives / Bank policies
                                    from time to time) which is deemed to be a
                                    part of this Sanction Letter. The Loan is
                                    also subject to the conditions that are
                                    contained in other documents executed/to be
                                    executed by the Borrower in favour of the
                                    Bank.
                                </li>
                                <li className="list-decimal list-inside openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                    All terms and conditions relating to the
                                    Loan and end use of funds would be subject
                                    to RBI regulations and directives from RBI
                                    from time to time.
                                </li>
                                <li className="list-decimal list-inside openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                    By clicking the “I Agree to the Sanction
                                    Letter” tab below you shall be signing,
                                    agreeing to and authenticating this Sanction
                                    Letter and the terms thereof.
                                </li>
                            </ol>
                            <p className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3 mt-8">
                                We look forward to partner you in your business.
                            </p>
                            <p className="openSans-Reg text-black text-sm md:text-lg xl:text-xl mb-3">
                                HDFC Bank Ltd.
                            </p>
                        </div>
                    </div>
                    <div className="container my-5 mx-auto sm:px-2 md:px-5">
                        <div className="w-full">
                            <div className="accord-wrap">
                                <Accordion
                                    title="Details of Borrower"
                                    open={true}
                                >
                                    <SanctionDetailsOfBorrower />
                                </Accordion>
                                <Accordion
                                    title="Charges (Including Govt Taxes &
                                            Levies)"
                                    open={true}
                                >
                                    <SanctionCharges />
                                </Accordion>
                                <Accordion
                                    title="Foreclosure Charges *"
                                    open={true}
                                >
                                    <SanctionForeclosureCharges />
                                </Accordion>
                                <Accordion
                                    title="Part-Payment Charges*"
                                    open={true}
                                >
                                    <SanctionPartPaymentCharges />
                                </Accordion>
                                <Accordion
                                    title="Loan Cancellation"
                                    open={true}
                                >
                                    <SanctionLoanCancellation />
                                </Accordion>
                                <Accordion
                                    title="Loan Re-schedulement & Re-Booking
                                            Charges"
                                    open={true}
                                >
                                    <SanctionLoanReschedulement />
                                </Accordion>
                                <Accordion title="Inter State NOC" open={true}>
                                    <SanctionInterStateNOC />
                                </Accordion>
                            </div>
                            <div className="flex flex-wrap w-full relative my-4 px-4">
                                <div className="relative w-full md:w-6/12 lg:w-4/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Documentation / Valuation Charges
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        <span className="WebRupee">Rs.</span>500
                                    </p>
                                </div>
                                <div className="relative w-full md:w-6/12 lg:w-8/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Conversion charges for switching from
                                        floating to fixed interest and
                                        vice-versa
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        60
                                    </p>
                                </div>
                                <div className="relative w-full md:w-6/12 lg:w-4/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Date of reset of interest rate
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        Not Applicable
                                    </p>
                                </div>
                                <div className="relative w-full md:w-6/12 lg:w-8/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Mode of communication of changes in
                                        interest rates
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        Not Applicable
                                    </p>
                                </div>
                                <div className="w-full">
                                    <div className="relative w-full md:w-6/12 lg:w-8/12 mb-3 md:mb-6">
                                        <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                            Details of security/collateral
                                            obtained
                                        </p>
                                        <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                            Hypothecation of vehicle details of
                                            which are mentioned in the Terms and
                                            Conditions. Fixed Deposit (if
                                            applicable)
                                        </p>
                                    </div>
                                </div>

                                <div className="relative w-full md:w-6/12 lg:w-4/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Date by which annual outstanding balance
                                        statement will be issued
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        31st May
                                    </p>
                                </div>
                                <div className="relative w-full md:w-6/12 lg:w-8/12 mb-3 md:mb-6">
                                    <p className="openSans-Reg block text-sm md:text-base lg:text-base xl:text-base leading-tight text-gray-500 pr-0 md:pr-2">
                                        Details of Security/ Vehicle(s)
                                    </p>
                                    <p className="openSans-Reg text-black font-22px leading-tight relative pr-0 md:pr-2">
                                        As per the Terms and Conditions
                                    </p>
                                </div>
                            </div>
                            <div className="bg-light-yellow text-grey-darkest openSans-Reg py-2 px-4 mt-3 md:mt-5 mb-40 md:mb-32 text-sm rounded">
                                <p className="mb-3 md:mb-5">
                                    * Foreclosure charges and part payment
                                    charges are exclusive of Govt Taxes &
                                    Levies. Govt Taxes & Levies and other
                                    Government levies, as applicable, would be
                                    charged additionally.
                                </p>
                                <p>
                                    ** Collateral Charges / PDD Collection
                                    Charges are refundable in case of Loan
                                    Cancellation.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="w-full bg-white box-shadow fixed bottom-0">
                    <div className="container mx-auto px-5">
                        <div className="w-full flex flex-wrap">
                            <button
                                className="button-blue-bg text-white my-4 py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue high-amt-apply-submit  mr-0 sm:mr-2 md:mr-2 lg:mr-3 xl:mr-4 transition-all"
                                title="Agree"
                                onClick={() =>
                                    props.history.push("/declaration")
                                }
                            >
                                Agree
                            </button>
                            <button
                                className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white my-4 py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue  transition-all"
                                title="Cancel"
                                onClick={() => props.history.push("/offer")}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
